import { FormRow } from "@dbn/omnichannel-design-system-g4p";
import { useFormatMessage } from "../../../../../../intl";
import { MoneyField } from "../../../../../../Common/Price/MoneyField/MoneyField";
import { RFieldProps } from "../domain";

export function R101Field(props: RFieldProps) {
  const formatMessage = useFormatMessage();

  return (
    <FormRow type="full">
      <MoneyField
        {...props.fieldProps}
        currency={props.currency}
        label={formatMessage(
          "StandardLoan.AdditionalIncome.IncomeSection.bruttoIncomeLabel"
        )}
        placeholder={formatMessage(
          "StandardLoan.AdditionalIncome.IncomeSection.bruttoIncomePlaceholder"
        )}
      />
    </FormRow>
  );
}
